import { Img, SubTitle } from 'components';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Text, RowDiv, SubSection, ColDiv, Div, SubWrap } from 'styles';
import { SubLayout } from 'layout';
import * as S from './ProductStyle';
import { LocationMap } from './LocationMap';

export function Product({ setRef, langList }) {
  const [list, setList] = useState();
  const [loading, setLoading] = useState(true);
  const [currentNav, setCurrentNav] = useState();

  useEffect(() => {
    if (langList) {
      setCurrentNav(langList.nav.filter((el) => el.path.includes(window.location.pathname.split('/')[1]))[0]);
      setList(langList.product);
      setLoading(false);
    }
  }, [langList]);

  useEffect(() => {
    if (list && setRef.current && sessionStorage.getItem('currentIndex')) {
      const index = Number(sessionStorage.getItem('currentIndex'));
      if (setRef.current[index]) {
        setTimeout(
          () =>
            setRef.current[index].scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'nearest',
            }),
          300,
        );
      }
    }
  }, [list, setRef.current]);

  return (
    list && (
      <SubLayout list={list} setRef={setRef} nav={langList.nav}>
        <SubSection>
          {list.products && list.products.map((product, productIndex) => {
            // 섹션 ref 인덱스 = 앞 제품들이 실제 렌더링한 섹션 수의 합 (제품·제품설치 + subject2/subject3 있으면 각 1)
            // navLang.js 제품소개 index 와 맞아야 함 (현재 D: 0~2, A: 3~5)
            const sectionCount = (p) => 2 + (p.subject2 ? 1 : 0) + (p.subject3 ? 1 : 0);
            const refIndex = list.products.slice(0, productIndex).reduce((sum, p) => sum + sectionCount(p), 0);

            return (
              <React.Fragment key={`product_${productIndex}`}>
                <SubWrap $type="first" ref={(el) => (setRef.current[refIndex] = el)}>
                  <ColDiv $gap={8}>
                    {/* 검색 키워드 라벨(eyebrow): 축사용 공기청정기 / 축사용 제습기 — 모델명 바로 위에 노출 */}
                    {product.category && (
                      <Div $padding="0 0 0 28px" $mPadding="0 0 0 20px">
                        <Text $type="h6" $mType="h8" $color="primary700">
                          {product.category}
                        </Text>
                      </Div>
                    )}
                    <SubTitle title={product.subject} desc={product.subjectDesc} type="product" />
                  </ColDiv>
                  <S.ImgBox>
                    <Img src={product.aeroQbitImg} alt={product.aeroQbitAlt || product.subject} $width={880} $height={536} $tWidth="100%" $tHeight={396} $mHeight="auto" />
                  </S.ImgBox>
                  <RowDiv $padding="16px" $gap={48} $mGap={16} $justifyContent="space-between" $mFlexDirection="column">
                    {product.productList.map((item, index) => (
                      <ColDiv key={`item_${index}`} $gap={24} $mGap={8} $maxWidth={320} $width="100%">
                        <Text $type="h5" $mType="h6" $color="primary300">
                          {item.title}
                        </Text>
                        {item.desc && (
                          <Text $whiteSpace="pre-wrap" $mType="b7">
                            {item.desc}
                          </Text>
                        )}
                        {item.content && (
                          <S.SpecGrid>
                            {item.content.map((con, idx) => (
                              <React.Fragment key={`con_${idx}`}>
                                <Text $type="h7" $mType="h8" $whiteSpace="nowrap">
                                  {con.label}
                                </Text>
                                <Text $mType="b7">{con.value}</Text>
                              </React.Fragment>
                            ))}
                          </S.SpecGrid>
                        )}
                      </ColDiv>
                    ))}
                  </RowDiv>
                </SubWrap>
                <SubWrap $type="first" ref={(el) => (setRef.current[refIndex + 1] = el)}>
                  <SubTitle title={product.subject1} desc={product.subject1Desc} />
                  {product.installProduct.length > 2 ? (
                    <S.InstallGrid>
                      {product.installProduct.map((i, index) => (
                        <S.InstallCard key={`i_${index}`}>
                          <S.InstallImgBox>
                            <Img src={i.img} alt={i.alt || i.label || product.subject} $height="100%" $objectFit="cover" />
                          </S.InstallImgBox>
                          {i.label && (
                            <Text $color="darker" $type="h6" $mType="h7" $textAlign="center">
                              {i.label}
                            </Text>
                          )}
                        </S.InstallCard>
                      ))}
                    </S.InstallGrid>
                  ) : (
                    <RowDiv $gap={16} $mFlexDirection="column" $justifyContent="center">
                      {product.installProduct.map((i, index) => (
                        <ColDiv key={`i_${index}`} $gap={8} $flex={1} $width="50%" $mWidth="100%">
                          <Img src={i.img} alt={i.alt || i.label || product.subject} $width="100%" $height={340} $mWidth="100%" $mObjectFit="cover" $mHeight="auto" />
                          {(i.label || i.desc) && (
                            <S.TextDiv>
                              {i.label && (
                                <Text $color="darker" $type="h6">
                                  {i.label}
                                </Text>
                              )}
                              {i.desc && (
                                <Text $type="b6" $mType="b7" $color="darker" $marginTop={4}>
                                  {i.desc}
                                </Text>
                              )}
                            </S.TextDiv>
                          )}
                        </ColDiv>
                      ))}
                    </RowDiv>
                  )}
                </SubWrap>
                {product.subject2 && (
                  <SubWrap ref={(el) => (setRef.current[refIndex + 2] = el)}>
                    <SubTitle title={product.subject2} desc={product.subject2Desc} />
                    {product.locationMap ? (
                      <LocationMap data={product.locationMap} />
                    ) : (
                      product.locationImg && (
                        <Img src={product.locationImg} $width="100%" $maxWidth={800} $height="auto" />
                      )
                    )}
                  </SubWrap>
                )}
                {product.subject3 && (
                  <SubWrap ref={(el) => (setRef.current[refIndex + 3] = el)}>
                    <SubTitle title={product.subject3} />
                  </SubWrap>
                )}
              </React.Fragment>
            );
          })}
        </SubSection>
      </SubLayout>
    )
  );
}
